import { createSelector } from 'reselect';

const getData = state => {
  return state;
};

export const filteredData = createSelector(
  getData,
  data => data.FilteredDataReducer
);
